
<nav class="top-menu">
  <ul class="horizontal-menu" *ngIf="authService.isLoggedIn()">
    <li *ngFor="let route of menuRoutes">
      <a [routerLink]="route.path" routerLinkActive="active">{{ route.title }}</a>
    </li>
  </ul>
  <div class="spacer"></div>
  <app-user-profile-dropdown *ngIf="authService.isLoggedIn()" (debugStreamToggle)="toggleStreamPopover()"></app-user-profile-dropdown>
  <button class="login-button" *ngIf="!authService.isLoggedIn()" (click)="login()">Login</button>
</nav>

<app-drawing-stream-popover [visible]="showStreamPopover" (closePopover)="closeStreamPopover()"></app-drawing-stream-popover>

<router-outlet />
